import { createEvent, createStore } from 'effector';
import { type PayoutCascadeFilters } from '~/entities/payout';
import { createPagination } from '~/shared/lib/pagination';

export const paginationModel = createPagination();

export const setCascadesFilter = createEvent<PayoutCascadeFilters>();
export const $cascadesFilter = createStore<PayoutCascadeFilters>({}).on(setCascadesFilter, (state, payload) => ({
    ...state,
    ...payload,
}));
